'use strict';

import {observable, observe, configure, action, makeObservable} from "mobx";
configure({enforceActions: 'always'});

import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import {getAggregateState} from '@uw-it-sis/lib-react/lib/StateUtils';

import acknowledgementsStore from "./AcknowledgementsStore";
import optionalChargesStore from "./OptionalChargesStore";

class PreRegWorkflowStore {
    state = States.initial;

    index = 0;

    dataLoadStates = {
        acknowledgements: States.initial,
        optionalcharges: States.initial
    };

    constructor() {
        makeObservable(this, {
            state: observable,
            mount: action,
            index: observable
        });
    }

    mount(onSuccess, termId) {
        this.dataLoadStates = {
            acknowledgements: States.pending,
            optionalcharges: States.pending
        }

        this.checkDataLoadStates();

        this.acknowledgementsDisposer = observe(acknowledgementsStore, "state", (change) => {
            // Set the data state for this store to the new value.
            this.dataLoadStates.acknowledgements = change.newValue;
            // Precipitate a UI update if the data loads have completed.
            this.checkDataLoadStates();
        });

        acknowledgementsStore.mount(onSuccess);

        this.optionalchargesDisposer = observe(optionalChargesStore, "state", (change) => {
            // Set the data state for this store to the new value.
            this.dataLoadStates.optionalcharges = change.newValue;
            // Precipitate a UI update if the data loads have completed.
            this.checkDataLoadStates();
        });

        optionalChargesStore.mount(onSuccess, termId);
    }

    /**
     * Check aggregate data load states and update the overall state if necessary.
     */
    checkDataLoadStates = () => {
        this.state = getAggregateState(this.dataLoadStates);
    }

    getRequiredAcknowledgements = () => {
        if (acknowledgementsStore.formData.hasOwnProperty("acknowledged")) {
            return Object.entries(acknowledgementsStore.formData.acknowledged).filter(([key, value]) => value === false);
        } else {
            return [];
        }
    }

    getOptChargesData = () => {
        return optionalChargesStore.data;
    }

    updateAcknowledgement = (name, value) => {
        acknowledgementsStore.updateAcknowledgement(name, value, true);
    }

    getAcknowledgementValue = (name) => {
        return acknowledgementsStore.getNewAcknowledgementValue(name);
    }

    savePreReg = () => {
        acknowledgementsStore.saveAcknowledgements();
        optionalChargesStore.saveOptCharges();
    }
}

export default new PreRegWorkflowStore();